<a class="ou-get-back" [routerLink]="'/'">
  <mat-icon class="material-icons-outlined">arrow_back_ios</mat-icon>
  <div class="ou-get-back-title">Szervezeti egységek</div>
</a>
<div class="ou-get-container">
  <div class="ou-get-name">
    <app-button
      *ngIf="user.isSuperAdminIn(organizationUnit.name)"
      (click)="layers()"
      [icon]="'edit'"
      [customColor]="'yellow'"
      [fontSize]="18"
    ></app-button>
    <div class="ou-get-title">{{organizationUnit.niceName}}</div>
  </div>
</div>
<app-organization-unit-project-list *ngIf="organizationUnit.name.length > 0" [organizationUnit]="organizationUnit" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
</app-organization-unit-project-list>
